import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  SovosBox,
  SovosButton,
  SovosPageLayout,
  SovosPaper,
  SovosTypography,
} from "mosaic-react";

const Result = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryResponse = location.state ? location.state.queryResponse : null;

  useEffect(() => {
    if (!queryResponse) {
      // Redirect the user to the homepage if the necessary data is not available
      navigate("/");
    }
  }, [navigate, queryResponse]);
  const handleClick = () => {
    navigate("/");
  };

  const handlePrint = () => {
    window.print();
  };
  return (
    <>
      {queryResponse && (
        <SovosPageLayout pageTitle="Resultados">
          <SovosPaper
            sx={{
              padding: 1,
              backgroundColor: "#F5F5F5",
              margin: 2,
            }}
          >
            <SovosTypography
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "2rem",
                padding: "1rem",
              }}
            >
              {queryResponse}
            </SovosTypography>
            <SovosBox
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "2rem",
                marginBottom: "1rem",
                gap: "1rem",
              }}
            >
              <SovosButton variant="contained" onClick={handleClick}>
                Volver
              </SovosButton>
              <SovosButton variant="contained" onClick={handlePrint}>
                Imprimir
              </SovosButton>
            </SovosBox>
          </SovosPaper>
        </SovosPageLayout>
      )}
    </>
  );
};

export default Result;
